module.exports = __webpack_public_path__ + "img/recommed-img9.5727d05b.jpg";